
define(["jquery", "uppsala", "history"], function ($, uppsala) {
    var originalTitle = document.title;
    var foodAuditFilter = {

           $resultsContainer: $("#filter-results"),
           init: function () {

                   //Fix för att tiden '00:00:00' läggs på vid reload av sidan, av någon märklig anledning...
                   $("#date").val($("#date").val().replace(" 00:00:00", ""));

                   // Tooltip med omdömestext
                   $("#explanation-text").hide();
                   var ariaState = false;

                   var tooltipIcon = $("#tooltip-icon");
                   $(tooltipIcon).click(function (e) {
                       e.preventDefault();
                       ariaState = !ariaState;
                       var tooltipText = $("#explanation-text");
                       $(tooltipText).attr("aria-hidden", ariaState ? "false" : "true");
                       $(tooltipIcon).attr("aria-pressed", !ariaState ? "false" : "true");
                       $(this).attr("aria-label", ariaState ? "Dölj beskrivning" : "Visa beskrivning");
                       $(tooltipText).toggle();
                       
                   });

                   $("#close-link").click(function (e) {
                       e.preventDefault();
                       var tooltipText = $("#explanation-text");
                       $(tooltipIcon).attr("aria-expanded", "false");
                       $(tooltipText).attr("aria-hidden", "true");
                       $(tooltipText).hide();
                       $("html, body").animate(
                           {
                               scrollTop: tooltipIcon.offset().top
                           }, 1);
                   });

                   if (window.History.enabled) {
                       $("#submit-filters-button").hide();

                       //Fix för att första sidladdningen utan KOMPLETT querystring blir en dubblett i history-listan, och därmed failar hela history-hanteringen.
                       //Denna rad måste stå före initializeHistoryStuff(), annars funkar det inte i Chrome!
                       foodAuditFilter.UpdateHistory(true);

                       foodAuditFilter.InitializeHistoryStuff();
                   }
           },
           //UPDATE HTML FOR INPUT FIELDS
           UpdateInputFields: function (historyState) {
               if (historyState.data != null) {
                   if (historyState.data.state.query != null) {
                       $("#query").val(historyState.data.state.query);
                   }
                   else {
                       $("#query").val("");
                   }
                   if (historyState.data.state.date != null) {
                       if ($("#date").val() != historyState.data.state.date) {
                           $("#date").val(historyState.data.state.date);
                       }
                   }
                   else {
                       $("#date").val("");
                   }
                   if (historyState.data.state.isbeforedate != null) {
                       $('#isbeforedate option[value="' + historyState.data.state.isbeforedate + '"]').prop("selected", true);
                   }
                   else {
                       $('#isbeforedate option[value="' + "" + '"]').prop("selected", true);
                   }

                   if (historyState.data.state.selectedTypes != null) {
                       foodAuditFilter.SetCheckBoxValues("selectedTypes", historyState.data.state.selectedTypes);
                   }
                   if (historyState.data.state.selectedResults != null) {
                       foodAuditFilter.SetCheckBoxValues("selectedResults", historyState.data.state.selectedResults);
                   }
               }
           },

           //GET ResultList HTML AND UPDATE HTML
           UpdateResultList: function (historyState) {
               var historyBaseUrl = historyState.url;
               var historyQueryString = "";
               var questionmarkIndex = historyState.url.indexOf("?");
               if (questionmarkIndex > -1) {
                   historyBaseUrl = historyBaseUrl.substring(0, questionmarkIndex);
                   historyQueryString = historyState.url.slice(questionmarkIndex + 1);

                   //Fix för att "lura" history-listan i IE och Chrome som cache:ar entrys,
                   //vilket gör att ajax-anropens fejkade entrys blir korrupta. Genom att
                   //ge ajax-anropen en url som skiljer sig från de vanliga anropen lurar
                   //vi history-cachen att cache:a på rätt sätt.
                   historyQueryString = "ajax=1&" + historyQueryString;
               }

               $.ajax({
                   url: historyBaseUrl,
                   type: "get",
                   data: historyQueryString,
                   dataType: "html",
                   success: function (response) {
                       foodAuditFilter.$resultsContainer.html(response);
                       uppsala.RssClickEvent();
                   },
                   error: function (request, status, errorThrown) {
                       //console.log("epic fail: " + errorThrown + ", " + status);
                   }
               });
           },

           //Pushes the "filter input control state" into history
           UpdateHistory: function (isInitial) {
               var query = $("#query").val();
               var date = $("#date").val();
               var isbeforedate = $("#isbeforedate").val();
               var types = foodAuditFilter.FormatCheckBoxListQueryString("selectedTypes");
               var resultTypes = foodAuditFilter.FormatCheckBoxListQueryString("selectedResults");

               var page = isInitial ? foodAuditFilter.GetQueryStringPart(window.location.search, "page") : "";
               var history = window.History;
               var state = history.getState();
             
               state.title = query !== '' ? query + ' - ' + originalTitle : originalTitle; 

               var hash = window.location.hash;

               if (hash !== "") {
                   var scrollPos = foodAuditFilter.$resultsContainer.offset().top;
                   $(window).scrollTop(scrollPos);
               }

               var queryString = "?query=" + encodeURIComponent(query) + "&page=" + page + "&date=" + date + "&isbeforedate=" + isbeforedate + types.query + resultTypes.query;
               if (isInitial) {
                   //Ser till att querystring är komplett vid första första sidladdningen och gör sedan replace på history entryt.
                   document.title = state.title;
                   history.replaceState({ state: { query: query, page: page, date: date, isbeforedate: isbeforedate, selectedTypes: types.checkedValues, selectedResults: resultTypes.checkedValues } }, state.title, queryString);
               } else {
                   history.pushState({ state: { query: query, page: page, date: date, isbeforedate: isbeforedate, selectedTypes: types.checkedValues, selectedResults: resultTypes.checkedValues } }, state.title, queryString);
               }
           },

           InitializeHistoryStuff: function () {
               // INPUT ON-KEYUP
               var timer;
               $("#query").keyup(function () {
                   var delay = 500;
                   clearTimeout(timer);
                   timer = setTimeout(function () {
                       foodAuditFilter.UpdateHistory(false);
                   }, delay);
               });

               // INPUT ON-CHANGE
               $("#date").change(function () {
                   foodAuditFilter.UpdateHistory(false);
               });
               //INPUT ON-KEYUP
               var timerDate;
               $("#date").keyup(function () {
                   var delay = 500;
                   clearTimeout(timerDate);
                   timerDate = setTimeout(function () {
                       foodAuditFilter.UpdateHistory(false);
                   }, delay);
               });

               // SELECT ON-CHANGE
               $("#isbeforedate").change(function () {
                   foodAuditFilter.UpdateHistory(false);
               });

               //INPUT CHECKBOX ON-CHANGE
               foodAuditFilter.BindCheckBoxListEvents("selectedTypes");
               foodAuditFilter.BindCheckBoxListEvents("selectedResults");

               History.Adapter.bind(window, "statechange", function () {
                   var historyState = window.History.getState();

                   //Uppdatera inmatningsfälten
                   foodAuditFilter.UpdateInputFields(historyState);

                   //Uppdatera resultatlistan
                   foodAuditFilter.UpdateResultList(historyState);
               });
           },

           //Binder change-eventet på checkboxlistorna så att historyn uppdateras på varje klick
           BindCheckBoxListEvents: function (inputName) {
               var checkBoxes = $("input[name='" + inputName + "']");
               var index;
               for (index = 0; index < checkBoxes.length; index++) {
                   //Sätter currentitem onload if checked
                   if ($(checkBoxes[index]).is(":checked")) {
                       $(checkBoxes[index]).closest("li").addClass("isActive");
                   }
                   $(checkBoxes[index]).change(function () {
                       $(this).closest("li").toggleClass("isActive");
                       foodAuditFilter.UpdateHistory(false);
                   });
               }
           },

           FormatCheckBoxListQueryString: function (inputName) {
               var values = [];
               var checkBoxes = $("input[name='" + inputName + "']");
               var index;
               var queryString = null;
               for (index = 0; index < checkBoxes.length; index++) {
                   if ($(checkBoxes[index]).is(":checked")) {
                       if (queryString == null) {
                           //To avoid 'null' from being written to the url
                           queryString = "";
                       }
                       var value = $(checkBoxes[index]).val();
                       values.push(value);
                       queryString = queryString + "&" + encodeURIComponent(inputName) + "=" + encodeURIComponent(value);
                   }
               }
               if (queryString == null)
                   queryString = "&" + encodeURIComponent(inputName) + "=";

               return {
                   checkedValues: values,
                   query: queryString
               };
           },

           SetCheckBoxValues: function (inputName, values) {
               var checkBoxes = $("input[name='" + inputName + "']");
               var index;
               for (index = 0; index < checkBoxes.length; index++) {
                   //Uncheck each checkbox first 
                   $(checkBoxes[index]).prop("checked", false);
                   $(checkBoxes[index]).closest("li").removeClass("isActive");

                   var value = $(checkBoxes[index]).val();
                   if (values.indexOf(value) > -1) {
                       $(checkBoxes[index]).prop("checked", true);
                       $(checkBoxes[index]).closest("li").addClass("isActive");
                   }
               }
           },

           GetQueryStringPart:function (url, key) {
                var vars = [], hash;

                var questionmarkIndex = url.indexOf("?");
                if (questionmarkIndex == -1) return "";

                var queryString = url.slice(questionmarkIndex + 1);

                var hashes = queryString.split("&");

                for (var i = 0; i < hashes.length; i++) {
                    hash = hashes[i].split("=");
                    vars.push(hash[0]);
                    vars[hash[0]] = hash[1];
                }

                if (!vars.hasOwnProperty(key)) {
                    return "";
                }
                return vars[key];
  
            }
       }

       return foodAuditFilter;
});